import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    
    /** 是否显示组件 */
    public isShowComponent: boolean = false;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/Aside/Modules.State.ts